import { SVGProps } from 'react'

export const NoResultsIconSMS = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="375" height="146" viewBox="0 0 375 146" fill="none" {...props}>
      <g filter="url(#filter0_d_2076_59902)">
        <path
          d="M79.5 42C79.5 33.1634 86.6634 26 95.5 26H342.54V58.21C342.54 67.0465 335.377 74.21 326.54 74.21H95.5C86.6634 74.21 79.5 67.0465 79.5 58.21V42Z"
          fill="white"
        />
        <path
          d="M80 42C80 33.4396 86.9396 26.5 95.5 26.5H342.04V58.21C342.04 66.7704 335.101 73.71 326.54 73.71H95.5C86.9396 73.71 80 66.7704 80 58.21V42Z"
          stroke="#C0C9CE"
        />
      </g>
      <rect x="94.7241" y="41.2246" width="231.746" height="6.76631" rx="3.38316" fill="#F2F5F7" />
      <rect x="94.7241" y="53.0654" width="179.307" height="6.76631" rx="3.38316" fill="#F2F5F7" />
      <g filter="url(#filter1_d_2076_59902)">
        <path
          d="M295.541 75C295.541 66.1634 288.377 59 279.541 59H32.5002V91.21C32.5002 100.047 39.6637 107.21 48.5002 107.21H279.541C288.377 107.21 295.541 100.047 295.541 91.21V75Z"
          fill="white"
        />
        <path
          d="M295.041 75C295.041 66.4396 288.101 59.5 279.541 59.5H33.0002V91.21C33.0002 99.7704 39.9398 106.71 48.5002 106.71H279.541C288.101 106.71 295.041 99.7704 295.041 91.21V75Z"
          stroke="#C0C9CE"
        />
      </g>
      <rect
        width="231.746"
        height="6.76631"
        rx="3.38316"
        transform="matrix(-1 0 0 1 280.316 74.2246)"
        fill="#F2F5F7"
      />
      <rect
        width="179.307"
        height="6.76631"
        rx="3.38316"
        transform="matrix(-1 0 0 1 227.808 86.0654)"
        fill="#F2F5F7"
      />
      <defs>
        <filter
          id="filter0_d_2076_59902"
          x="47.5"
          y="0"
          width="327.041"
          height="112.21"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2076_59902" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2076_59902"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_2076_59902"
          x="0.5"
          y="33"
          width="327.041"
          height="112.21"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6" />
          <feGaussianBlur stdDeviation="16" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0 0.6625 0 0 0 0.2 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2076_59902" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2076_59902"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  )
}
